import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "app-circle-button",
	standalone: false,
	templateUrl: "./circle-button.component.html",
	styleUrls: ["./circle-button.component.scss"],
})
export class CircleButtonComponent {
	@Input() diameterPx = 50;
	@Input() label?: string;

	@Output() clicked = new EventEmitter<void>();

	handleClick(event: MouseEvent) {
		event.stopPropagation(); // optional: prevent bubbling
		this.clicked.emit();
	}

	get style() {
		return {
			width: `${this.diameterPx}px`,
			height: `${this.diameterPx}px`,
			lineHeight: `${this.diameterPx}px`,
			borderRadius: "50%",
		};
	}
}
